import React from 'react';
import { translate } from '@utils/i18n';
import { Modal } from '@components/v2/Modal';
import { Button } from '@ui';
import './styles.scss';
const NS = 'features.iim_review.confirm_modal';
export default function ConfirmBulkActionModal({ isOpen, onClose, onConfirm, actionType, count, hasNonSuggestableWarning = false }) {
    const hasCount = count != null && count > 0;
    const getActionConfig = () => {
        switch (actionType) {
            case 'dismiss':
                return {
                    title: hasCount
                        ? translate('confirm_dismiss_selected_title', { namespace: NS, count })
                        : translate('confirm_dismiss_all_title', { namespace: NS }),
                    description: hasCount
                        ? translate('confirm_dismiss_selected_description', { namespace: NS, count })
                        : translate('confirm_dismiss_all_description', { namespace: NS }),
                    confirmButton: hasCount
                        ? translate('confirm_dismiss_selected', { namespace: NS, count })
                        : translate('confirm_dismiss', { namespace: NS })
                };
            case 'suggest':
                return {
                    title: hasCount
                        ? translate('confirm_suggest_selected_title', { namespace: NS, count })
                        : translate('confirm_suggest_all_title', { namespace: NS }),
                    description: hasCount
                        ? translate('confirm_suggest_selected_description', { namespace: NS, count })
                        : translate('confirm_suggest_all_description', { namespace: NS }),
                    confirmButton: hasCount
                        ? translate('confirm_suggest_selected', { namespace: NS, count })
                        : translate('confirm_suggest', { namespace: NS })
                };
            case 'undo_dismiss':
                return {
                    title: hasCount
                        ? translate('confirm_undo_selected_dismissed_title', { namespace: NS, count })
                        : translate('confirm_undo_all_dismissed', { namespace: NS }),
                    description: hasCount
                        ? translate('confirm_undo_selected_dismissed_description', { namespace: NS, count })
                        : translate('confirm_undo_dismiss_all_description', { namespace: NS }),
                    confirmButton: hasCount
                        ? translate('confirm_undo_selected', { namespace: NS, count })
                        : translate('confirm_undo_dismissed', { namespace: NS })
                };
            case 'undo_suggest':
                return {
                    title: hasCount
                        ? translate('confirm_undo_selected_suggested_title', { namespace: NS, count })
                        : translate('confirm_undo_all_suggested_corrections', { namespace: NS }),
                    description: hasCount
                        ? translate('confirm_undo_selected_suggested_description', { namespace: NS, count })
                        : translate('confirm_undo_suggest_all_description', { namespace: NS }),
                    confirmButton: hasCount
                        ? translate('confirm_undo_selected', { namespace: NS, count })
                        : translate('confirm_undo_suggested_corrections', { namespace: NS })
                };
            case 'undo_resolve':
                return {
                    title: hasCount
                        ? translate('confirm_undo_selected_resolved_title', { namespace: NS, count })
                        : translate('confirm_undo_all_resolved', { namespace: NS }),
                    description: hasCount
                        ? translate('confirm_undo_selected_resolved_description', { namespace: NS, count })
                        : translate('confirm_undo_resolve_all_description', { namespace: NS }),
                    confirmButton: hasCount
                        ? translate('confirm_undo_selected', { namespace: NS, count })
                        : translate('confirm_undo_resolved', { namespace: NS })
                };
            default:
                return undefined;
        }
    };
    const config = getActionConfig();
    if (!config) {
        return null;
    }
    return (React.createElement(Modal, { title: config.title, isOpen: isOpen, onClose: onClose, className: "confirm-bulk-action-modal", width: "500px", footer: React.createElement(React.Fragment, null,
            React.createElement(Button, { onClick: onClose }, translate('cancel', { namespace: 'features.commons' })),
            React.createElement(Button, { variant: "primary", onClick: () => {
                    onConfirm();
                } }, config.confirmButton)) },
        React.createElement("div", { className: "confirm-bulk-action-content" },
            React.createElement("p", { className: "confirm-bulk-action-description" }, config.description),
            actionType === 'suggest' && hasNonSuggestableWarning && (React.createElement("p", { className: "confirm-bulk-action-warning" },
                React.createElement("i", { className: "fa-light fa-circle-info" }),
                " ",
                translate('non_suggestable_warning', { namespace: NS }))))));
}
